/**
 * Offers shown on the results screen.
 *
 * Static for now, matching the Figma exactly. The shape is deliberately the
 * shape an API would return, so swapping this module for a fetch later is a
 * change to one import rather than to the offers screen.
 *
 * `tone` drives the ribbon and button colour only — it is presentation, not
 * meaning. `id` is what gets recorded against the lead, so it must stay stable
 * even if the marketing copy changes.
 */
export const HOME_OFFERS = [
  {
    id: 'ee-mobile-fibre',
    ribbon: 'Super Value Saver',
    tone: 'value',
    name: 'EE Mobile Fibre',
    image: '/brand/offers/ee-mobile-fibre.png',
    price: { pounds: 18, pence: '95' },
    period: 'Per month',
    features: [
      { strong: 'Up to 56mb/s', rest: ' Download speed' },
      { strong: null, rest: 'Linked to your ee mobile' },
      { strong: null, rest: 'Unlimited Usage' },
      { strong: null, rest: 'Zero month rolling contract!' },
    ],
  },
  {
    id: 'sky-super-fibre-500',
    ribbon: 'Best Suited To You',
    tone: 'best',
    name: 'SKY Super Fibre 500',
    image: '/brand/offers/sky-super-fibre-500.png',
    price: { pounds: 28, pence: '99' },
    period: 'Per month',
    features: [
      { strong: 'Up to 500mb/s', rest: ' Download speed' },
      { strong: null, rest: 'Discounts on Sky TV packages' },
      { strong: null, rest: 'Unlimited Usage' },
      { strong: null, rest: '24 months rolling contract' },
    ],
  },
  {
    id: 'talktalk-gigabit',
    ribbon: 'Fastest Speed Offer',
    tone: 'fastest',
    name: 'TalkTalk Gigabit',
    image: '/brand/offers/talktalk-gigabit.png',
    price: { pounds: 35, pence: '00' },
    period: 'Per month',
    features: [
      { strong: 'Up to 1000mb/s', rest: ' Download speed' },
      { strong: 'Up to 80mb/s', rest: ' Upload speed' },
      { strong: null, rest: 'Unlimited Usage' },
      { strong: null, rest: '24 months rolling contract' },
    ],
  },
];

/**
 * The business journey does not show tariffs at all — the details form is the
 * gate, and the offers are promised rather than displayed. That is the design,
 * not an omission, so business simply has no offer list.
 */
export function offersForBrand(brand) {
  return brand === 'business' ? [] : HOME_OFFERS;
}
